module.exports = __webpack_public_path__ + "static/media/demo.52fea66a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/_projects/regexly/demo.jpg
// module id = 271
// module chunks = 0